import { DsoTaxon, DsoTaxonClient, DsoTaxonResponse } from 'types/dso';
import RestUtility from '../../../restUtility';
import { dsoTaxonEndPoint } from '../../../restUtility/restEndpoints';
import { notifyError } from 'config/setupBugsnag';

export class DsoTaxonService {
  private restUtility: RestUtility;

  constructor() {
    this.restUtility = new RestUtility();
  }

  async getTaxonDetails(): Promise<DsoTaxonClient[]> {
    try {
      const response = await this.restUtility.get<DsoTaxonResponse>(
        `${dsoTaxonEndPoint}`
      );
      return this.buildDsoTaxon(response.data);
    } catch (error) {
      notifyError('ApiError:: DSO::getTaxonDetails', error);
      throw error;
    }
  }

  buildDsoTaxon(response: DsoTaxon[]): DsoTaxonClient[] {
    return response.map(taxon => ({
      title: taxon.name,
      permalink: taxon.permalink,
      isChild: taxon.is_child,
      breadcrumbs: taxon.breadcrumbs.reverse(),
    }));
  }
}
